<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {useCallStore} from "../../../store/calls"
import {useModalStore} from "../../../store/modal"
import {useUserStore} from "../../../store/users"
import {useAuthStore} from "../../../store/auth"
import {computed, onMounted, ref} from "vue";

const options = []
const loading = ref(false)
const store = useCallStore()
const modalStore = useModalStore()
const userStore = useUserStore()
const is_created = ref(false)


const description = computed(() =>
    is_created.value
        ? "Call has been created."
        : "Are you sure you want to create a call?"
)
const users = ref([])
const authStore = useAuthStore()
const isAdmin = computed(() => ['reseller-super-admin', 'reseller-team-leader', 'super-admin', 'internal-super-admin', 'internal-team-leader'].includes(authStore.user.roles[0].name))
const assigned_user = ref(null)

const createCall = async () => {
    loading.value = true
    await store.createCall(modalStore.props.uuid)
    if (assigned_user.value) {
        await store.assignCall(store.call.id, assigned_user.value)
    }
    loading.value = false
    is_created.value = true
}

onMounted(async () => {
    await userStore.getAllUsers({all: false, role: 'internal-agent'});
    users.value = isAdmin.value ? userStore.users : [authStore.user]

    users.value.forEach(u => {
        options.push({
            value: u.id,
            label: `${u.first_name} ${u.last_name}`
        })
    })
})
</script>

<template>
<DefaultModalBase :description :heading="is_created ? 'Call Created' : 'Create Call'" :icon="is_created ? 'check-all' : 'call-default'" :loading :refresh="is_created">

    <div class="call-assign-container">
        <brand-button variant="secondary" v-if="is_created" @click="modalStore.close(true)">Done</brand-button>
        <brand-form-select label="Assign to." :options="options" v-model="assigned_user" v-if="!is_created"/>
        <brand-button @click="createCall()" :disabled="loading" v-if="!is_created">Create Call</brand-button>
    </div>
</DefaultModalBase>
</template>

<style scoped lang="scss">
.call-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
